/*
 *  使用方法
 *  将以下代码复制到一个drag.js文件中，然后在入口文件main.js中导入：import ‘./util/drog.js’；
 *  给elementUI的dialog上加上 v-drag-dialog 指令就可以实现弹窗的全屏和拉伸了。
 *  给dialog设置 :close-on-click-modal="false" , 禁止点击遮罩层关闭弹出层
 *  如果是form表单，不要将提交等按钮放置el-form-item，以免在上下拉伸时被隐藏
 */
// v-drag-dialog: 弹窗拖拽+水平方向伸缩
export default {
  bind(el, binding, vnode) {
    // const minWidth = 1000
    // const minHeight = 620
    const dialogHeaderEl = el.querySelector('.el-dialog__header')
    const dragDom = el.querySelector('.el-dialog')
    dialogHeaderEl.style.cssText += ';cursor:move;'
    dragDom.style.cssText += ';top:0px;'
    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
    const getStyle = (function () {
      if (window.document.currentStyle) {
        return (dom, attr) => dom.currentStyle[attr]
      } else {
        return (dom, attr) => getComputedStyle(dom, false)[attr]
      }
    })()
    const moveDown = (e) => {
      // 鼠标按下，计算当前元素距离可视区的距离
      const disX = e.clientX - dialogHeaderEl.offsetLeft
      const disY = e.clientY - dialogHeaderEl.offsetTop
      const dragDomWidth = dragDom.offsetWidth
      const dragDomHeight = dragDom.offsetHeight

      const screenWidth = document.body.clientWidth
      const screenHeight = document.body.clientHeight

      const minDragDomLeft = dragDom.offsetLeft
      const maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth

      const minDragDomTop = dragDom.offsetTop
      const maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomHeight

      // 获取到的值带px 正则匹配替换
      let styL = getStyle(dragDom, 'left')
      let styT = getStyle(dragDom, 'top')

      if (styL.includes('%')) {
        // styL = +document.body.clientWidth * (+styL.replace(/\%/g, '') / 100)
        // styT = +document.body.clientHeight * (+styT.replace(/\%/g, '') / 100)
      } else {
        styL = +styL.replace(/\px/g, '')
        styT = +styT.replace(/\px/g, '')
      }

      document.onmousemove = function (e) {
        // 通过事件委托，计算移动的距离
        let left = e.clientX - disX
        let top = e.clientY - disY

        // 边界处理
        if (-left > minDragDomLeft) {
          left = -minDragDomLeft
        } else if (left > maxDragDomLeft) {
          left = maxDragDomLeft
        }

        if (-top > minDragDomTop) {
          top = -minDragDomTop
        } else if (top > maxDragDomTop) {
          top = maxDragDomTop
        }

        // 移动当前元素
        dragDom.style.cssText += `;left:${left + styL}px;top:${top + styT}px;`

        // emit onDrag event
        vnode.child.$emit('dragDialog')
      }
      // document.removeEventListener('mouseup', this.stopDrag)
      document.onmouseup = function (e) {
        document.onmousemove = null
        document.onmouseup = null
      }
    }
    const stopDrag = (e) => {
      document.onmousemove = null
      document.onmouseup = null
    }
    // 当前宽高
    // let nowWidth = 0
    // dialogHeaderEl.onmousedown = moveDown
    dialogHeaderEl.addEventListener('mousedown', moveDown)
    dialogHeaderEl.addEventListener('mouseup', stopDrag)
    // dragDom.onmousemove = function (e) {
    //   // let moveE = e
    //   if (
    //     e.clientX > dragDom.offsetLeft + dragDom.clientWidth - 10 ||
    //     dragDom.offsetLeft + 10 > e.clientX
    //   ) {
    //     dragDom.style.cursor = 'w-resize'
    //   } else if (el.scrollTop + e.clientY > dragDom.offsetTop + dragDom.clientHeight - 10) {
    //     dragDom.style.cursor = 's-resize'
    //   } else {
    //     dragDom.style.cursor = 'default'

    //     dragDom.onmousedown = null
    //   }
    //   dragDom.onmousedown = (e) => {
    //     const clientX = e.clientX
    //     const clientY = e.clientY
    //     const elW = dragDom.clientWidth
    //     const elH = dragDom.clientHeight
    //     const EloffsetLeft = dragDom.offsetLeft
    //     const EloffsetTop = dragDom.offsetTop
    //     dragDom.style.userSelect = 'none'
    //     const ELscrollTop = el.scrollTop
    //     // 判断点击的位置是不是为头部
    //     if (
    //       clientX > EloffsetLeft &&
    //       clientX < EloffsetLeft + elW &&
    //       clientY > EloffsetTop &&
    //       clientY < EloffsetTop + 100
    //     ) {
    //       // 如果是头部在此就不做任何动作，以上有绑定dialogHeaderEl.onmousedown = moveDown;
    //     } else {
    //       document.onmousemove = function (e) {
    //         // 移动时禁用默认事件
    //         e.preventDefault()
    //         // 左侧鼠标拖拽位置
    //         if (clientX > EloffsetLeft && clientX < EloffsetLeft + 10) {
    //           // 往左拖拽
    //           if (clientX > e.clientX) {
    //             dragDom.style.width = elW + (clientX - e.clientX) * 2 + 'px'
    //           }
    //           // 往右拖拽
    //           if (clientX < e.clientX) {
    //             if (dragDom.clientWidth < minWidth) {
    //               console.log()
    //             } else {
    //               dragDom.style.width = elW - (e.clientX - clientX) * 2 + 'px'
    //             }
    //           }
    //         }
    //         // 右侧鼠标拖拽位置
    //         if (clientX > EloffsetLeft + elW - 10 && clientX < EloffsetLeft + elW) {
    //           // 往左拖拽
    //           if (clientX > e.clientX) {
    //             if (dragDom.clientWidth < minWidth) {
    //               console.log()
    //             } else {
    //               dragDom.style.width = elW - (clientX - e.clientX) * 2 + 'px'
    //             }
    //           }
    //           // 往右拖拽
    //           if (clientX < e.clientX) {
    //             dragDom.style.width = elW + (e.clientX - clientX) * 2 + 'px'
    //           }
    //         }
    //         // 底部鼠标拖拽位置
    //         if (
    //           ELscrollTop + clientY > EloffsetTop + elH - 20 &&
    //           ELscrollTop + clientY < EloffsetTop + elH
    //         ) {
    //           // 往上拖拽
    //           if (clientY > e.clientY) {
    //             if (dragDom.clientHeight < minHeight) {
    //               console.log()
    //             } else {
    //               dragDom.style.height = elH - (clientY - e.clientY) * 2 + 'px'
    //             }
    //           }
    //           // 往下拖拽
    //           if (clientY < e.clientY) {
    //             dragDom.style.height = elH + (e.clientY - clientY) * 2 + 'px'
    //           }
    //         }
    //       }
    //       // 拉伸结束
    //       document.onmouseup = function (e) {
    //         document.onmousemove = null

    //         document.onmouseup = null
    //       }
    //     }
    //   }
    // }
  },
  update(el, binding) {
    if (getComputedStyle(el, null).display === 'none') {
      const dragDom = el.querySelector('.el-dialog')
      dragDom.style.cssText += `;left:${0}px;top:${0}px;`
    }
  }
}
